import React,{useEffect,useState} from "react";
import Header from "../../../shared/layout/Header";
import ProductList from "../../products/components/ProductList";
import HomeHero from "../components/HomeHero";
import HomeCategories from "../components/HomeCategories";
import HomeSection from "../components/HomeSection";
import ShippingFeatures from "../../../shared/layout/ShippingFeatures";
import Footer from "../../../shared/layout/Footer";
import BottomFooter from "../../../shared/layout/BottomFooter";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../../../shared/layout/ColorInit";
import { CartProvider } from "../../cart/context/CartContext";
import TrendingProducts from "../components/TrendingProducts";
import HomeCollections from "../components/HomeCollections";
import Products999 from "../components/Products999";
import PromotionalSlider from "../components/PromotionalSlider";
import { getBanners } from "../api";
import { S3_URL_BANNERS, SITE_URL, SITE_NAME, DEFAULT_SEO_IMAGE } from "../../../shared/utils/constants";
import PromoBanner from "../components/PromoBanner";
import FloatingCouponButton from "../../coupons/components/FloatingCouponButton";
import Seo from "../../../shared/ui/Seo";

// Lets search engines show the store name, logo and a site search box.
const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: SITE_URL,
    logo: DEFAULT_SEO_IMAGE,
    telephone: "+94777961772",
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: SITE_URL,
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE_URL}/search?query={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  },
];

const HomePage = () => {
  const [mainBanners, setMainBanners] = useState([]);
  const [subBannerLine1, setSubBannerLine1] = useState([]);
  const [subBannerLine2, setSubBannerLine2] = useState([]);
  const [modalBanner, setModalBanner] = useState(null);
  const [fetched, setFetched]       = useState(false)
  // null until the 999 section loads; when it is empty both sub banner lines
  // would sit back to back, so they are shown as one slider instead.
  const [has999Products, setHas999Products] = useState(null);
  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const token  = params.get("accessToken");
  if (token) {
    localStorage.setItem("accessToken", token);
    // optionally: remove it from the URL so you don’t keep passing it around
    window.history.replaceState({}, "", window.location.pathname);
  }
}, []);
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await getBanners();
        if (response && response.length > 0) {
          // Map MAIN_BANNER_LINE banners
          const main = response
            .filter((banner) => banner.type === "MAIN_BANNER_LINE")
            .map((banner, index) => ({
              src: `${S3_URL_BANNERS}${banner.imageName}`,
              alt: banner.heading || `Banner ${index + 1}`,
              url: banner.url && banner.url.trim() ? banner.url : "/",
            }));

          // Each image appears once across the two sub banner lines, even if
          // it is configured for both (line 1 keeps it).
          const seenSubImages = new Set();
          const isNewSubImage = (banner) =>
            !seenSubImages.has(banner.imageName) &&
            seenSubImages.add(banner.imageName);

          // Map SUB_BANNER_LINE1 banners
          const sub1 = response
            .filter((banner) => banner.type === "SUB_BANNER_LINE1")
            .filter(isNewSubImage)
            .map((banner, index) => ({
              src: `${S3_URL_BANNERS}${banner.imageName}`,
              alt: banner.heading || `Sub Banner 1 - ${index + 1}`,
              url: banner.url && banner.url.trim() ? banner.url : "/",
            }));

          // Map SUB_BANNER_LINE2 banners
          const sub2 = response
            .filter((banner) => banner.type === "SUB_BANNER_LINE2")
            .filter(isNewSubImage)
            .map((banner, index) => ({
              src: `${S3_URL_BANNERS}${banner.imageName}`,
              alt: banner.heading || `Sub Banner 2 - ${index + 1}`,
              url: banner.url && banner.url.trim() ? banner.url : "/",
            }));

            const latestModal = (
              response
                .filter((b) => b.type === "MODAL_BANNER_LINE")
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
            )[0] || null;
    
            if (latestModal) {
              setModalBanner({
                src: `${S3_URL_BANNERS}${latestModal.imageName}`,
                alt: latestModal.heading || "Promotional Banner",
                url: latestModal.url?.trim() || "/",
              });
            }

          setMainBanners(main);
          setSubBannerLine1(sub1);
          setSubBannerLine2(sub2);
        }
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
      finally {
        setFetched(true)
      }
    };

    fetchBanners();
  }, []);
  return (
    <CartProvider>
      <Seo path="/" jsonLd={homeJsonLd} />
      <ScrollToTop smooth color="#ef253c" />
      <FloatingCouponButton />
      <ColorInit color={'bigmall'} />
      <Header  />
      <main className="home-page">
      <h1 className="visually-hidden">Bigmall - Online Shopping in Sri Lanka</h1>
      <div className="home-main container container-lg">
      <HomeHero banners={mainBanners} loading={!fetched} />
      {fetched && modalBanner && <PromoBanner banner={modalBanner} />}
      <TrendingProducts />
      <HomeCategories />
      <PromotionalSlider
        banners={
          has999Products === false
            ? [...subBannerLine1, ...subBannerLine2]
            : subBannerLine1
        }
      />
      <Products999 onLoaded={(count) => setHas999Products(count > 0)} />
      {has999Products !== false && (
        <PromotionalSlider banners={subBannerLine2} />
      )}
      <HomeCollections />
      <HomeSection title="Just For You">
        <ProductList pageSize={18} bare />
      </HomeSection>
      </div>
      </main>
      <ShippingFeatures />
      <Footer />
      <BottomFooter />
      
    </CartProvider>
  
  );
};

export default HomePage;
